export const MA_DEALS_FIELDS_ENUM = {
  ACQUISITION_COST: 'dealReservesAcquisitionCost',
  PRICE_FLOWING_BARREL: 'dealPriceFlowingBarrel',
  CONSIDERATION_BY_RESERVES: 'dealConsiderationByReserves',
  CONSIDERATION_BY_PRODUCTION: 'dealConsiderationByProduction',
};

export const MA_DEALS_FIELDS_LABELS = {
  [MA_DEALS_FIELDS_ENUM.ACQUISITION_COST]: 'Acquisition Cost (US$/boe)',
  [MA_DEALS_FIELDS_ENUM.PRICE_FLOWING_BARREL]: 'Price per Flowing Barrel (US$/boe)',
  [MA_DEALS_FIELDS_ENUM.CONSIDERATION_BY_RESERVES]: 'Consideration by Reserves (US$/boe)',
  [MA_DEALS_FIELDS_ENUM.CONSIDERATION_BY_PRODUCTION]: 'Consideration by Production (US$/boe)',
};

export const MA_DEALS_FIELDS_OPTIONS = Object.values(MA_DEALS_FIELDS_ENUM);
